/**
 * PHARMAKON — Journal d'audit, browser twin (cross-module X · XWP-64, CP §15.2, XO-13, XMD-CP-17).
 *
 * Owner of the values: `apps/server/src/config/audit-descriptions.config.js` (the action nouns and
 * the entity families of the « Entité » filter) and the Prisma enum `ActionAudit` (the actions the
 * GET /audit validator accepts). This file is a twin, not an import, because the API image is built
 * from apps/server alone. The server test `src/__tests__/audit-journal.parity.test.js` imports both
 * and fails on any drift (PK-BUG-15) — change a value on the server first, then here.
 *
 * The sentence of a row, its link and its entity label are NOT here: the server computes them at
 * read time and serves them on every row (`description`, `lien`, `entite_libelle`).
 */

/** ActionAudit, in the schema's order, with the noun the journal shows (NOMS_ACTION_AUDIT). */
export const ACTIONS_JOURNAL_AUDIT = Object.freeze([
  Object.freeze({ value: "CREATE", libelle: "Création" }),
  Object.freeze({ value: "UPDATE", libelle: "Modification" }),
  Object.freeze({ value: "DELETE", libelle: "Suppression" }),
  Object.freeze({ value: "VALIDATE", libelle: "Validation" }),
  Object.freeze({ value: "CANCEL", libelle: "Annulation" }),
  Object.freeze({ value: "PRINT", libelle: "Impression" }),
  Object.freeze({ value: "EXPORT", libelle: "Export" }),
  Object.freeze({ value: "LOGIN", libelle: "Connexion" }),
  Object.freeze({ value: "LOGOUT", libelle: "Déconnexion" }),
  Object.freeze({ value: "ACCESS", libelle: "Consultation" }),
]);

/**
 * The « Entité » filter: each value is a family of FAMILLES_ENTITE_AUDIT — the server reads every
 * stored `entite` of the family (the table the services write and the route segment older rows
 * carry, XD-252). Order: the documents first, then stock, cash, people, settings.
 */
export const FILTRE_ENTITES_AUDIT = Object.freeze([
  Object.freeze({ value: "ventes", libelle: "Vente" }),
  Object.freeze({ value: "achats", libelle: "Achat" }),
  Object.freeze({ value: "avoirs", libelle: "Avoir" }),
  Object.freeze({ value: "efactures", libelle: "E-Facture" }),
  Object.freeze({ value: "produits", libelle: "Produit" }),
  Object.freeze({ value: "stock_lots", libelle: "Lot de stock" }),
  Object.freeze({ value: "fournisseurs", libelle: "Fournisseur" }),
  Object.freeze({ value: "caisses", libelle: "Caisse" }),
  Object.freeze({ value: "tresorerie", libelle: "Trésorerie" }),
  Object.freeze({ value: "support_tickets", libelle: "Ticket d'assistance" }),
  Object.freeze({ value: "users", libelle: "Utilisateur" }),
  Object.freeze({ value: "pharmacie", libelle: "Pharmacie" }),
]);
